import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../../assets/styles/index.css";
import logoImg from "../../assets/img/logo.svg";
import naver from "../../assets/img/naver.svg";
import facebook from "../../assets/img/facebook.png";
import instagram from "../../assets/img/instagram.png";
import CompanyMap from "./CompanyMap";
import WorksMap from "./WorksMap";
import CommunityMap from "./CommunityMap";
import ContactMap from "./ContactMap";

function Navbar() {
  const [navbarOpen, setNavbarOpen] = React.useState(false);
  const [scrolling, setScrolling] = useState(false);
  const [selectedTab, setSelectedTab] = useState("company"); // Default tab
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // 이벤트 리스너 정리
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    // URL이 변경될 때마다 selectedTab을 업데이트
    const currentPath = location.pathname;
    switch (currentPath) {
      case "/company":
        setSelectedTab("company");
        break;
      case "/company2":
        setSelectedTab("company2");
        break;
      case "/company3":
        setSelectedTab("company3");
        break;
      case "/works":
        setSelectedTab("works");
        break;
      case "/works2":
        setSelectedTab("works2");
        break;
      case "/works3":
        setSelectedTab("works3");
        break;
      case "/works4":
        setSelectedTab("works4");
        break;
      case "/community":
        setSelectedTab("community");
        break;
      case "/community2":
        setSelectedTab("community2");
        break;
      case "/community3":
        setSelectedTab("community3");
        break;
      case "/contact":
        setSelectedTab("contact");
        break;
      case "/contact2":
        setSelectedTab("contact2");
        break;
      case "/contact3":
        setSelectedTab("contact3");
        break;
      default:
        setSelectedTab("company");
        break;
    }
  }, [location.pathname]);

  return (
    <div>
      <nav
        className={`fixed top-0 z-50 flex-col flex-wrap items-center justify-between w-full font-sans navbar-expand-lg ${
          scrolling ? "fade-out" : ""
        }`}
      >
        <div className="border-b border-gray-200">
        <div className="container flex flex-wrap items-center justify-between h-20 px-4 mx-auto bg-white">
          <div className="relative flex lg:block lg:justify-between">
            <Link
              to="/"
              className="z-20 inline-block leading-relaxed whitespace-nowrap"
            >
              <img src={logoImg} alt="logo" className="h-6" />
            </Link>
          </div>
          <div
            className={
              "lg:flex items-center lg:bg-opacity-0 lg:shadow-none z-50"
            }
          >
            <ul className="z-50 hidden group lg:flex lg:list-none lg:ml-auto">
              <div className="flex h-20 gap-4 text-center">
                <li className="flex items-center justify-center w-36">
                  <Link to="/company">
                    <span
                      className={
                        location.pathname.startsWith("/company")
                          ? "flex items-center justify-center text-sm font-semibold text-center group text-main"
                          : "flex items-center justify-center text-sm font-semibold text-center group text-gray-950 hover:text-main"
                      }
                    >
                      회사 소개
                    </span>
                  </Link>
                  {/* invisible */}
                  <div className="absolute top-0 left-0 flex flex-col justify-center invisible w-full pt-20 pb-10 text-sm text-gray-400 bg-white shadow-md backdrop-blur-sm -z-10 group-hover:visible">
                    <div className="flex justify-center gap-4">
                      <div className="flex-col w-36">
                        <Link to="/company">
                          <p className="mb-2 text-gray-600 hover:text-main">
                            코끼리협동조합
                          </p>
                        </Link>
                        {/* <Link to="/company2">
                          <p className="mb-2 text-gray-600 hover:text-main">
                            팀 소개
                          </p>
                        </Link> */}
                        <Link to="/company3">
                          <p className="text-gray-600 hover:text-main">연혁</p>
                        </Link>
                      </div>

                      {/* 사업 소개 */}
                      <div className="flex-col w-36">
                        <Link to="/works">
                          <p className="mb-2 text-gray-600 hover:text-main">
                            사업 소개
                          </p>
                        </Link>
                        <Link to="/works2">
                          <p className="mb-2 text-gray-600 hover:text-main">
                            지역사회 문제 해결
                          </p>
                        </Link>
                        <Link to="/works3">
                          <p className="mb-2 text-gray-600 hover:text-main">
                            메이커 스페이스 운영
                          </p>
                        </Link>
                        <Link to="/works4">
                          <p className="text-gray-600 hover:text-main">
                            창업 지원
                          </p>
                        </Link>
                      </div>

                      {/* 커뮤니티 */}
                      <div className="flex-col w-36">
                        <Link to="/community">
                          <p className="mb-2 text-gray-600 hover:text-main">
                            공지사항
                          </p>
                        </Link>
                        <Link to="/community2">
                          <p className="mb-2 text-gray-600 hover:text-main">
                            활동 소식
                          </p>
                        </Link>
                        <Link to="/community3">
                          <p className="text-gray-600 hover:text-main">
                            뉴스레터
                          </p>
                        </Link>
                      </div>

                      {/* 문의 */}
                      <div className="flex-col w-36">
                        <Link to="/contact">
                          <p className="mb-2 text-gray-600 hover:text-main">
                            상담 신청
                          </p>
                        </Link>
                        <Link to="/contact2">
                          <p className="mb-2 text-gray-600 hover:text-main">
                            FAQ
                          </p>
                        </Link>
                        <Link to="/contact3">
                          <p className="text-gray-600 hover:text-main">
                            오시는 길
                          </p>
                        </Link>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="flex items-center justify-center w-36">
                  <Link to="/works">
                    <span
                      className={
                        location.pathname.startsWith("/works")
                          ? "flex items-center justify-center text-sm font-semibold text-center group  text-main"
                          : "flex items-center justify-center text-sm font-semibold text-center group text-gray-950 hover:text-main"
                      }
                    >
                      {" "}
                      사업 소개
                    </span>
                  </Link>
                </li>

                <li className="flex items-center justify-center w-36">
                  <Link to="/community">
                    <span
                      className={
                        location.pathname.startsWith("/community")
                          ? "flex items-center justify-center text-sm font-semibold text-center group  text-main"
                          : "flex items-center justify-center text-sm font-semibold text-center group text-gray-950 hover:text-main"
                      }
                    >
                      {" "}
                      커뮤니티
                    </span>
                  </Link>
                </li>

                <li className="flex items-center justify-center w-36">
                  <Link to="/contact">
                    <span
                      className={
                        location.pathname.startsWith("/contact")
                          ? "flex items-center justify-center text-sm font-semibold text-center group  text-main"
                          : "flex items-center justify-center text-sm font-semibold text-center group text-gray-950 hover:text-main"
                      }
                    >
                      {" "}
                      문의
                    </span>
                  </Link>
                </li>
              </div>
            </ul>
            <div className="lg:hidden">
              <button
                className="block px-3 py-1 text-xl leading-none bg-transparent border-transparent outline-none cursor-pointer focus:outline-none"
                type="button"
                onClick={() => setNavbarOpen(!navbarOpen)}
              >
                <i className="fas fa-bars" style={{ color: "black" }}></i>
              </button>
            </div>
          </div>
          <div className="hidden lg:items-center lg:justify-center lg:gap-3 lg:flex">
            <Link
              to="/"
              className="inline-block leading-relaxed whitespace-nowrap"
            >
              <img src={naver} alt="logo" className="w-6 h-6" />
            </Link>
            <Link
              to="/"
              className="inline-block leading-relaxed whitespace-nowrap"
            >
              <img src={facebook} alt="logo" className="w-6 h-6" />
            </Link>
            <Link
              to="/"
              className="inline-block leading-relaxed whitespace-nowrap"
            >
              <img src={instagram} alt="logo" className="w-6 h-6" />
            </Link>
          </div>
        </div>
        </div>
        <div
          className={`absolute flex flex-col justify-center gap-2 text-sm text-center rounded-md shadow-md right-6 lg:hidden md:right-14 h-36 w-36 ${
            navbarOpen ? "visible" : "invisible"
          }`}
        >
          {" "}
          <Link to="/company">
            <p className="text-gray-950 hover:font-bold">회사 소개</p>
          </Link>
          <p className="text-gray-950 hover:font-bold">사업 소개</p>
          <p className="text-gray-950 hover:font-bold">커뮤니티</p>
          <p className="text-gray-950 hover:font-bold">문의</p>
        </div>
        {/* 추가 */}
        <div
          className={`container flex flex-col w-full px-4 mx-auto mt-8 transition-opacity duration-200 ${
            scrolling ? "opacity-0" : "opacity-100"
          }`}
        >
          {selectedTab.startsWith("company") && <CompanyMap />}
          {selectedTab.startsWith("works") && <WorksMap />}
          {selectedTab.startsWith("community") && <CommunityMap />}
          {selectedTab.startsWith("contact") && <ContactMap />}
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
